/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Detail_All_BranchesInputs */

const en_users_detail_all_branches = /** @type {(inputs: Users_Detail_All_BranchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All branches`)
};

const pt_br2_users_detail_all_branches = /** @type {(inputs: Users_Detail_All_BranchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todas as filiais`)
};

/**
* | output |
* | --- |
* | "All branches" |
*
* @param {Users_Detail_All_BranchesInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_detail_all_branches = /** @type {((inputs?: Users_Detail_All_BranchesInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Detail_All_BranchesInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_detail_all_branches(inputs)
	return pt_br2_users_detail_all_branches(inputs)
});